/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    

    export class StatusGroupService {
        
        constructor(private $q: angular.IQService, private $http:angular.IHttpService) {
        }

        public getProcessStates(id: string): angular.IPromise<Wars.Domain.Model.Dtos.Workflow.StatusGroupsDto> {
            var d = this.$q.defer();
            this.$http.get('./api/ProcessConfiguration/' + id + '/Statuses').then(r => {
                d.resolve(r.data);
            });
            return d.promise;
        }

        public getProcessStatesWithDetails(id: string): angular.IPromise<Wars.Domain.Model.Dtos.Workflow.StatusGroupsDto> {
            var d = this.$q.defer();
            this.$http.get('./api/ProcessConfiguration/' + id + '/Statuses/AllData').then(r => {
                d.resolve(r.data);
            });
            return d.promise;
        }
    }
}

warsApp.registerService('StatusGroupService', ['$q','$http']);